import api from "src/apis/api";

/**
 * Fetch the current organization details.
 */
export function fetchOrganization() {
  return api.get("/api/v1/organization");
}

/**
 * Switch the active organization for the current session.
 */
export function switchOrganizationApi(organizationId) {
  return api.post("/api/v1/switch_organization", { organization_id: organizationId });
}

/**
 * Update organization name and/or logo.
 * Uses FormData to support file uploads.
 *
 * @param {{ name?: string, logo?: File }} params
 */
export function updateOrganization({ name, logo }) {
  const formData = new FormData();

  if (name !== undefined) {
    formData.append("organization[name]", name);
  }
  if (logo) {
    formData.append("organization[logo]", logo);
  }

  return api.patch("/api/v1/organization", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
